/**
 * Created by YJZX-LCH on 2017-05-04.
 */
import axios from './axios.js';

export default {
  //签字列表
  getSignatureList(dateValue) {
    return axios.get('/api/classAttendance',{
      params:{
        signTime:dateValue
      }
    }).then(response => {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  //签字生成图片/回显已签子图片
  getSignatureImage(list) {
    return axios.get(`/api/image?id=${list.id}&status=${list.status}&signStatus=${list.signStatus}&createTime=${list.createTimes}`).then(response => {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  //提交签字
  SubmitSignatureImage(fileData) {
    return axios.post(`/api/signaturePicture`,fileData).then(response => {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  //查询自定义签字图片
  getCustomSignatureImage() {
    return axios.get(`/api/customPicture`).then(response => {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
  //自定义签字图片提交
  SubmitCustomSignatureImage(fileData) {
    return axios.post(`/api/customSignature`,fileData).then(response => {
      if (response.status !== 200) {
        throw new Error('接口返回错误');
      } else {
        return response.data;
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/myclass.js